// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import auditRecommendationEntity from './entities/audit-recommendation.json';
import auditRecommendationMenu from '../pages/audit-recommendation/menu.json';
import auditRecommendationFullForm from '../pages/audit-recommendation/forms/full.json';
import auditRecommendationContextForm from '../pages/audit-recommendation/forms/context.json';
import auditRecommendationMiniForm from '../pages/audit-recommendation/forms/mini.json';
import auditRecommendationLookupForm from '../pages/audit-recommendation/forms/lookup.json';
import auditRecommendationTableView from '../pages/audit-recommendation/views/table.json';
import auditRecommendationCardsView from '../pages/audit-recommendation/views/cards.json';
import auditRecommendationCalendarView from '../pages/audit-recommendation/views/calendar.json';
import auditRecommendationDashboardView from '../pages/audit-recommendation/views/dashboard.json';

/** Тип запису «Рекомендація» зі сторінками пакета: меню, форми та подання з pages/audit-recommendation/. */
export const auditRecommendationDefinition: IRecordTypeDefinition = {
  ...auditRecommendationEntity,
  views: assembleViewSet({
      table: auditRecommendationTableView,
      cards: auditRecommendationCardsView,
      calendar: auditRecommendationCalendarView,
      dashboard: auditRecommendationDashboardView,
  }),
  form: auditRecommendationFullForm,
  forms: { full: auditRecommendationFullForm, context: auditRecommendationContextForm, mini: auditRecommendationMiniForm, lookup: auditRecommendationLookupForm },
  menu: auditRecommendationMenu,
} as IRecordTypeDefinition;
